// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__255n0"};